jQuery( document ).ready(function() {
  
  jQuery('header-menu details').on('hover', function(){
     jQuery(this).children().trigger('click');
  });

  jQuery('div.spf-product__swatchs span.spf-product__swatch').on('click', function(){
      var paroductID = jQuery(this).attr('data-product');
      jQuery('.product-sku span.'+paroductID).text(jQuery(this).attr('sku'));
  });

  var links = document.links;
  // for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  //     if (links[i].hostname !== window.location.hostname) {
  //       links[i].target = '_blank';
  //       links[i].rel = 'noreferrer noopener';
  //     }
  // }

  for (var i = 0, linksLength = links.length ; i < linksLength ; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
  }

  jQuery('div#assemblyGuides + div.accordion-container .accordion + .panel ul li strong').each(function(){
      jQuery(this).parent().attr('class', jQuery(this).text().replace(/\s+/g, '-').toLowerCase());
  })
  
});